import React from "react";

const Popup = ({ open, setOpen, title, description }) => {
  return (
    <div
      className={`${
        open ? "fixed" : "hidden"
      } bg-black/20 inset-0 w-full h-full z-[100] flex flex-col items-center justify-center`}
      onClick={() => setOpen(false)}
    >
      <div
        className="relative max-w-[95%] w-full px-5 py-10 sm:p-10 sm:max-w-xl md:max-w-2xl bg-black border border-solid border-gold shadow-md shadow-gold/50 rounded-md"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg md:text-2xl font-georgia text-gold">{title} </h2>
        <p className="my-3">{description}</p>
        {/* <button className="px-10 py-3 bg-transparent border border-solid border-gold rounded-md hover:bg-gold text-gold hover:text-black transition-all">
          Go Back
        </button> */}

        <button
          className="absolute top-5 right-5 text-gold font-bold"
          onClick={() => setOpen(false)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="size-6"
          >
            <path
              fillRule="evenodd"
              d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Popup;
